<template>
  <div class="box grow cursor-pointer" @click="gotoHost()">
    <div class="box flex row">
      <span
        class="small-font"
        v-if="notificationDetails.eventAction === 'STATUS_CHANGE'"
        >[ {{ agentLabel }} ] The status has changed to
        {{ notificationDetails.eventCategory }}.</span
      >
      <span
        class="small-font"
        v-else-if="notificationDetails.eventAction === 'PROGRESSION'"
        >[ {{ agentLabel }} ] New threat progression has been detected.</span
      >
      <span class="small-font" v-else
        >[ {{ agentLabel }} ] The risk level has escalated to
        {{ notificationDetails.riskLevel }}.</span
      >
    </div>
    <div
      class="box flex grow"
      v-if="notificationDetails.eventAction === 'SEVERITY_CHANGE'"
    >
      <risk-level-button
        v-if="
          notificationDetails.eventCategory === 'LOW_MED' ||
          notificationDetails.eventCategory === 'LOW_HIGH'
        "
        :risk-level="'low'"
        class-list="box notification-action_before"
      />
      <risk-level-button
        v-else
        :risk-level="'medium'"
        class-list="box notification-action_before"
      />
      <div class="box">
        <i class="material-icons">arrow_forward</i>
      </div>
      <risk-level-button
        v-if="
          notificationDetails.eventCategory === 'LOW_HIGH' ||
          notificationDetails.eventCategory === 'MED_HIGH'
        "
        :risk-level="'high'"
        class-list="box notification-action_after"
      />
      <risk-level-button
        v-else
        :risk-level="'medium'"
        class-list="box notification-action_after"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import RiskLevelButton from "@/components/button/RiskLevelButton.vue";
import { getUserFriendlyAgentLabel } from "@/utilities/agent.helper";

export default {
  name: "NotificationHostEvent",
  props: {
    notificationDetails: { type: Object }
  },
  data() {
    return {};
  },
  computed: {
    agentLabel() {
      return _.has(this.notificationDetails, 'hostname') ?
        this.notificationDetails.hostname :
        getUserFriendlyAgentLabel(this.notificationDetails.eventResourceId);
    }
  },
  methods: {
    gotoHost() {
      this.$emit("notification-toggle");
      this.$router.push({
        name: `dashboard-hosts`,
        params: {
          agentId: _.has(this.notificationDetails, 'eventResourceId') 
            ? this.notificationDetails.eventResourceId
            : this.notificationDetails.hostname
        }
      });
    }
  },
  components: {
    RiskLevelButton
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";
@import "assets/styles/riskscore_colors.css";

.notification-feed {
  background-color: var(--gray-50);
  margin: 10px 20px;
}

.card-content_icon {
  margin: auto 10px;

  > .box {
    line-height: 100px;
    vertical-align: middle;
  }

  .material-icons {
    border: 1px solid var(--main-gray);
    border-radius: 50%;
    color: white;
    background-color: var(--main-gray);
    padding: 2px;
  }
}

.card-content_details {
  margin: 10px 12px;

  > .box {
    margin: 10px 0px;
  }

  > .box:last-of-type {
    .box {
      margin-right: auto;
    }

    .notification-action_before,
    .notification-action_after {
      border: 1px solid var(--border-color);
      padding: 3px 10px;
      position: relative;
    }

    .notification-action_before::before {
      content: "";
      display: block;
      background-color: black;
      height: 1px;
      position: absolute;
      max-width: 105%;
      width: 105%;
      top: 50%;
      left: -2px;
    }
  }
}

.notification-action {
  .material-icons {
    font-size: 18px;
  }
}

.notification-action_mark_read {
  margin: 2px 0px;

  .circle {
    width: 14px;
    height: 14px;
    display: table-cell;
    border-radius: 50%;
    background: var(--primary-blue-400);
  }

  .read {
    background: var(--gray-200);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/card/notification/NotificationHostEvent.vue